import ResizeListener from "../../utility/ResizeListener";
import { WHITE_COLOR } from "../resources/colorsManager";
import Navbar from "./Navbar";

const MainLayout = ({ children }) => {
  const { width, height } = ResizeListener();

  return (
    <div
      style={{
        backgroundColor: WHITE_COLOR,
        width: "width",
        height: "height",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Navbar />

      {/* maxWidth: "1440px"  */}
      <div
        style={{
          display: "flex",
          padding: "10px",
          boxSizing: "border-box",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
